export enum ModalType {
  KnockOut = 'knock_out',
  Warning = 'warning',
}
